// @ts-nocheck
export const defaultMasterRootId = 'root-master';
export const defaultHistoryType = 'browser';
export const qiankunStateForSlaveModelNamespace = '@@qiankunStateForSlave';
export const qiankunStateFromMasterModelNamespace = '@@qiankunStateFromMaster';
